// extracted by mini-css-extract-plugin
module.exports =  {"tabs":"Tabs-g59G__tabs"};